import React, { useState } from "react";
import {
    Card,
    Form,
    Input,
    Button,
    message,
    Breadcrumb,
    Divider,
    Row,
    Col,
    Spin,
    Space,
} from "antd";
import {
    SaveOutlined,
    ArrowLeftOutlined,
    HomeOutlined,
    DollarOutlined,
    PlusOutlined,
    TagOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { cnfAPIWithErrorHandling } from "../../../api/invoice/cnf";


export default function StoreInvoiceCnf() {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    // Handle form submission
    const handleSubmit = async (values) => {
        setSubmitting(true);
        try {
            // API call to create template
            const response = await cnfAPIWithErrorHandling.createCnf(values);

            if (response.data && response.data.success) {
                message.success("Thêm cấu hình thành công!");
            } else {
                throw new Error(response.data?.message || "Lỗi không xác định.");
            }

            form.resetFields();
            navigate("/invoice-accounts");
        } catch (error) {
            message.error(error.message || "Không thể thêm cấu hình");
            console.error("Error creating template:", error);
        } finally {
            setSubmitting(false);
        }
    };

    // Các hàm khác không thay đổi
    const handleReset = () => { form.resetFields(); message.info("Đã xóa tất cả dữ liệu nhập"); };
    const handleBack = () => { navigate("/invoice-accounts"); message.info("Quay lại danh sách cấu hình"); };

    return (
        <div className="bg-gray-50 min-h-screen p-6">
            <Card className="shadow-lg max-w-7xl mx-auto">
                {/* Breadcrumb */}
                <div className="mb-6">
                    <Breadcrumb
                        separator=">"
                        className="mb-4"
                        items={[
                            { href: "/", title: (<><HomeOutlined /> Trang chủ</>) },
                            { href: "/invoice-accounts", title: (<><DollarOutlined /> Cấu hình</>) },
                            { title: (<><PlusOutlined /> Thêm mới</>) },
                        ]}
                    />
                </div>

                <Divider />

                {/* Form */}
                <Spin spinning={submitting} tip="Đang lưu thông tin...">
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                        requiredMark="optional"
                        className="space-y-4"
                        initialValues={{}}
                    >
                        <Row gutter={24}>
                            {/* CỘT THÔNG TIN CHUNG */}
                            <Col xs={24} lg={24}>
                                <Card
                                    title={
                                        <span className="text-blue-600">
                                            <TagOutlined className="mr-2" />
                                            Thông tin chung
                                        </span>
                                    }
                                    className="h-full shadow-sm border-blue-200"
                                >
                                    <Form.Item
                                        name="name"
                                        label={<span className="font-medium">Tên cấu hình (*)</span>}
                                        rules={[
                                            { required: true, message: "Vui lòng nhập tên cấu hình!" },
                                            { max: 255, message: "Tên mẫu không được vượt quá 255 ký tự!" },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Nhập tên cấu hình"
                                            size="default"
                                            className="rounded-lg"
                                        />
                                    </Form.Item>
                                    
                                    <Form.Item
                                        name="config_code"
                                        label={<span className="font-medium">Code cấu hình (*)</span>}
                                        rules={[
                                            { required: true, message: "Vui lòng nhập mã code cấu hình!" },
                                            { max: 255, message: "Code mẫu không được vượt quá 255 ký tự!" },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Nhập code cấu hình"
                                            size="default"
                                            className="rounded-lg"
                                        />
                                    </Form.Item>
                                </Card>
                            </Col>
                        </Row>

                        {/* Action Buttons */}
                        <Card className="mt-6 shadow-sm bg-gradient-to-r from-blue-50 to-green-50">
                            <Row
                                justify="space-between"
                                align="middle"
                            >
                                <Col>
                                    <Button
                                        icon={<ArrowLeftOutlined />}
                                        onClick={handleBack}
                                        size="default"
                                        className="shadow-sm"
                                    >
                                        Quay lại
                                    </Button>
                                </Col>
                                <Col>
                                    <Space size="small">
                                        <Button
                                            type="default"
                                            size="default"
                                            onClick={handleReset}
                                            className="min-w-32 rounded-lg shadow-sm"
                                        >
                                            Làm mới
                                        </Button>
                                        <Button
                                            type="primary"
                                            size="default"
                                            htmlType="submit"
                                            loading={submitting}
                                            icon={<SaveOutlined />}
                                            className="min-w-40 rounded-lg shadow-sm bg-gradient-to-r from-blue-500 to-blue-600 border-none"
                                        >
                                            {submitting ? "Đang lưu..." : "Lưu thông tin"}
                                        </Button>
                                    </Space>
                                </Col>
                            </Row>
                        </Card>
                    </Form>
                </Spin>
            </Card>
        </div>
    );
}